module.exports = __webpack_public_path__ + "static/media/logo.a69744a0.png";